<template>
  <Modal v-show="showModal">
    <FormCard
      :title="title"
      @accept="addRevision"
      @cancel="cancelAction"
    >
      <FormRevisionContent
        @handleRevisionData="setRevisionData"
        :revisionData="this.revisionData"
        :revisionDataValidation="this.revisionDataValidation"
        @onChangeReceivedDate="onChangeReceivedDate"
        @onChangeRevisedDate="onChangeRevisedDate"
        @onChangeAprovedDate="onChangeAprovedDate"
      />
    </FormCard>
  </Modal>
</template>

<script>
import Modal from '@/components/atoms/Modals/Modal.vue';
import FormCard from '@/components/molecules/FormCard/FormCard.vue';
import { hasData, getValidationState } from '@/helpers/ValidationHelper';
import FormRevisionContent from './FormRevisionContent.vue';

export default {
  name: 'AddRevisionForm',
  components: {
    Modal,
    FormCard,
    FormRevisionContent,
  },
  props: {
    showModal: Boolean,
    handleClose: {},
    officeUuid: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    title: 'Nueva Revisión',
    revisionData: {
      receivedDate: null,
      revisedDate: null,
      approvedDate: null,
      supplierUuid: null,
    },
    revisionDataValidation: {
      receivedDate: null,
      revisedDate: null,
      approvedDate: null,
      supplierUuid: null,
    },
  }),
  created() {
    if (typeof this.officeUuid !== 'undefined' && this.officeUuid !== '') {
      this.revisionData.officeUuid = this.officeUuid;
    }
    if (this.$store.getters.getUserSupplier && this.$store.getters.isSupplier) {
      this.revisionData.supplierUuid = this.$store.getters.getUserSupplier;
    }
  },
  methods: {
    setRevisionData(revisionData) {
      this.revisionData = revisionData;
    },
    addRevision() {
      if (this.isValidData()) {
        this.blockScreen();

        this.$store.dispatch('addRevision', this.revisionData)
          .then(() => {
            this.unBlockScreen();
            this.$emit('updateRevisions');
            this.closeForm();
          })
          .catch((error) => {
            this.unBlockScreen();
            this.closeForm();
            this.$store.commit('setErrors', error);
          });
      } else {
        this.revisionDataValidation = {
          receivedDate: getValidationState(this.revisionData?.receivedDate),
        };
      }
    },
    isValidData() {
      return hasData(this.revisionData?.receivedDate);
    },
    cancelAction() {
      this.$emit('cancel');
    },
    closeForm() {
      return this.handleClose();
    },
    onChangeReceivedDate(receivedDate) {
      this.revisionData.receivedDate = receivedDate;
    },
    onChangeRevisedDate(revisedDate) {
      this.revisionData.revisedDate = revisedDate;
    },
    onChangeAprovedDate(approvedDate) {
      this.revisionData.approvedDate = approvedDate;
    },
  },
};
</script>
